//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/tabs'
import 'devextreme/ui/toolbar'
import 'devextreme/ui/popup'
import 'devextreme/ui/progress_bar'
import 'devextreme/ui/select_box'

//#endregion

import { Api, LocalDictionaryFactory } from './../../api/api.module'

import { CreateEditPopupController, CreateEditPopupOptions } from './create-edit-popup.controller'

//#region Service Imports

import { $SCOPE_SERVICE_NAME, $COMPILE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'
import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService } from '../../../services/data-type'
import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeService } from '../../../services/reference-type'
import { OperatorSecurityService, OPERATOR_SECURITY_SERVICE_NAME } from '../../../services/operator'

//#endregion

//#region Asset Imports

import './create-edit-popup.scss'
import * as TEMPLATE from './create-edit-popup.tpl.html'

//#endregion

export class CreateEditPopupDirective implements ng.IDirective {
	restrict = 'E'

	scope = {
		options: '=',
		editPassword: '=',
		additionalDetailFieldsInGrid: '=?',
	}

	controller = [
		$SCOPE_SERVICE_NAME,
		$COMPILE_SERVICE_NAME,
		$Q_SERVICE_NAME,
		$TIMEOUT_SERVICE_NAME,
		'api',
		'localDictionary',
		DATA_TYPE_FORMAT_SERVICE_NAME,
		GRID_SERVICE_NAME,
		USER_SESSION_SERVICE_NAME,
		OPERATOR_SECURITY_SERVICE_NAME,
		REFERENCE_TYPE_SERVICE_NAME,
		(
			$scope,
			$compile: ng.ICompileService,
			$q,
			$timeout: ng.ITimeoutService,
			api: Api,
			localDictionary: LocalDictionaryFactory,
			dataTypeFormatService: DataTypeFormatService,
			gridService: GridService,
			userSessionService: UserSessionService,
			operatorSecurityService: OperatorSecurityService,
			referenceTypeService: ReferenceTypeService
		) => new CreateEditPopupController($scope, $compile, $q, $timeout, api, localDictionary, dataTypeFormatService, gridService, userSessionService, operatorSecurityService, referenceTypeService),
	]

	template = TEMPLATE

	transclude = true
}

export { CreateEditPopupOptions }
